import { differenceInMinutes } from "date-fns";
import { RefreshAction } from "../actions/RefreshAction";
import Tracking from "../tracking/Tracking";
let timer: number | null = null;
const JWTChecker = {
	updateData: {} as Record<string, any>,
	start: (jwt: string) => {
		if (jwt !== JWTChecker.updateData.jwt) {
			JWTChecker.updateData = {
				lastUpdate: new Date(),
				jwt: jwt,
			};
			JWTChecker.checkRepeatedly();
		}
	},
	stop: () => {
		if (timer) {
			window.clearInterval(timer);
		}

		JWTChecker.updateData = {};
	},
	checkRepeatedly: () => {
		if (!timer) {
			timer = window.setInterval(() => {
				const difference = differenceInMinutes(new Date(), JWTChecker.updateData.lastUpdate);

				if (difference > 60) {
					Tracking.trackStructuredEvent("platform", "uidispatcher", "technical.forcedRefresh", {
						tags: {
							minutes: difference,
						},
					});
					RefreshAction();
				}
			}, 1000);
		}
	},
	resetTimer: () => {
		if (timer) {
			window.clearInterval(timer);
			timer = null;
		}
	},
};
export default JWTChecker;
